const agoliaSettings = {
    agoliaAppId: '70KZCAJRYC',
    searchAPIKey: 'f4efc044d287539cf16dfbaf18303d92'
}
const API_ENDPOINT ='/form-post'
export {
    agoliaSettings,
    API_ENDPOINT
}
